var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{staticClass:"menuButton",class:{ 'r-l': _vm.menulist.id },attrs:{"to":_vm.menulist.to
          ? _vm.base + _vm.menulist.to
          : _vm.menulist.id
          ? _vm.base + '/cmsContent/' + _vm.menulist.id
          : '',"target":"_self","href":"#"}},[_vm._v("\n      "+_vm._s(_vm.menulist.name)+"\n    ")]),_vm._l((_vm.menulist.submenu),function(vm,vind){return _c('menubar',{key:vind,attrs:{"menulist":vm}})})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }